import { getEvaneosThemeOptions } from '@b2b-ui/theme/theme';
import { ThemeOptions, ThemeProvider, createTheme } from '@mui/material';
import React from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';

import { palette } from './colors';
import { EvaneosToolsProvider } from './providers/EvaneosToolsProvider';
import { pxToRem } from './utils';
import './toast.css';

type EvaneosProviderProps = {
    children: React.ReactNode;
    setTheme?: (evaneosTheme: ThemeOptions) => ThemeOptions;
    rootHtmlFontSize?: number;
    toastConfig?: ToastContainerProps;
};

export const EvaneosThemeProvider = ({
    children,
    setTheme = (theme) => theme,
    rootHtmlFontSize = 16,
    toastConfig,
}: EvaneosProviderProps) => {
    return (
        <ThemeProvider
            theme={createTheme(
                setTheme(getEvaneosThemeOptions(rootHtmlFontSize))
            )}
        >
            <EvaneosToolsProvider rootHtmlFontSize={rootHtmlFontSize}>
                {children}
                <ToastContainer
                    style={{
                        fontSize: pxToRem(16, rootHtmlFontSize),
                        //@ts-expect-error
                        '--toastify-color-success': palette.primary.main,
                        //@ts-expect-error
                        '--toastify-color-warning': palette.warning.main,
                        //@ts-expect-error
                        '--toastify-color-error': palette.error.main,
                        //@ts-expect-error
                        '--toastify-text-color-warning': palette.text.primary,
                    }}
                    position="bottom-left"
                    autoClose={3000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable
                    pauseOnHover
                    theme="colored"
                    {...toastConfig}
                />
            </EvaneosToolsProvider>
        </ThemeProvider>
    );
};
